

import React from 'react'
import Navbar from '../components/Navbar'

const Dashboard = (props) => {
  return (
    <div className='dashboard__header'>
        <Navbar 
          userID = {props.userID}
          copied={props.copied}  
          setCopied={props.setCopied}    
          toggleTransacrionPage={props.toggleTransacrionPage}
          toggleAccountPage={props.toggleAccountPage} 
          accountPage={props.accountPage} 
          transactionPage={props.transactionPage}
        />
    </div>
  )
}

export default Dashboard